<i [class]="icon()"></i>
